import { T } from '../../i18n/copy';
import Reveal from '../Reveal';
import SectionHead from '../SectionHead';
import ImageSlot from '../ImageSlot';

export default function About({ lang }) {
  const t = T.about;
  return (
    <section id="about-navartha" data-header-theme="bone" data-testid="about-section" className="editorial-margins bg-bone py-8 md:py-8">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <SectionHead eyebrow={t.eyebrow[lang]} index={t.index} />
          <Reveal className="mt-8">
            <h2 className="max-w-xl font-tight font-semibold text-[clamp(1.75rem,2.5vw,2.2rem)] leading-[1.12] tracking-[-0.02em] text-midnight">
              {t.headline[lang]}
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="mt-5 max-w-lg">
            <p className="text-base leading-snug text-midnight/70">{t.body1[lang]}</p>
            <p className="mt-4 font-serif text-lg italic leading-snug text-midnight md:text-xl">
              {t.combine[lang]} {t.combineList[lang].map((item, i) => (
                <span key={item}>
                  {item}
                  {i < t.combineList[lang].length - 1 && <span className="not-italic text-vermilion"> / </span>}
                </span>
              ))}
            </p>
            <p className="mt-4 text-base leading-snug text-midnight/70">{t.body2[lang]}</p>
          </Reveal>
          <Reveal delay={0.15} className="mt-5">
            <p className="eyebrow text-steel-dark">{t.approachLabel[lang]}</p>
            <ul className="mt-4 border-t border-midnight/12">
              {t.approachList[lang].map((item, i) => (
                <li key={item} className="flex items-baseline gap-4 border-b border-midnight/12 py-[7px]" data-testid={`about-approach-${i}`}>
                  <span className="eyebrow text-vermilion">0{i + 1}</span>
                  <span className="text-base text-midnight/80">{item}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        <div className="relative lg:col-span-5">
          <Reveal delay={0.1} className="relative">
            <div className="hidden sm:block">
              <ImageSlot slotKey="about" className="max-h-[280px] w-full lg:max-h-[400px]" />
            </div>
            <div data-testid="about-visual-panel" className="border-t border-midnight/15 pt-3 sm:mt-3">
              <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 sm:grid-cols-4 sm:gap-x-5">
                {t.visual[lang].map((w, i) => (
                  <div key={w} className="flex items-baseline gap-2">
                    <span className="eyebrow shrink-0 text-vermilion">{`0${i + 1}`}</span>
                    <span className="whitespace-nowrap font-tight text-[13px] font-medium tracking-[0.02em] text-midnight">{w}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
